import type { ReactNode } from "react"

const gapClassNames = {
  3: "gap-3",
  6: "gap-6",
  8: "gap-8",
} as const

interface SiteContentColumnProps {
  children: ReactNode
  className?: string
  gap?: keyof typeof gapClassNames
}

export function SiteContentColumn({ children, className, gap = 8 }: SiteContentColumnProps) {
  const classes = ["mx-auto flex w-full max-w-180 flex-col", gapClassNames[gap], className]
    .filter(Boolean)
    .join(" ")

  return <div className={classes}>{children}</div>
}
